module.exports = __webpack_public_path__ + "img/jumpilla-5.c4e76dd4.jpg";